export interface UnsavedGroup {
  groupCode: string;
  businessName: string;
  acknowledgementEmailBody: string;
  sendEmailFooterText: string;
  sendToStudio: boolean;
  suppressAcknowledgement: boolean;
  numberOfDaysToKeepClosedCases: number;
  authenticationType: AuthenticationType;
  studioUrl: string;
  studioClientId: string;
  sendImagesToStudio: boolean;
  studioApiVersion: number;
  studioTimezone: string;
  pollingPaused: boolean;
  sendTransferFormsToStudio: boolean;
  actionExtractAccountDataId: number|null;
  actionClassifyEmailId: number|null;
  actionExtractTransferFormDataId: number|null;
  closeWithoutSending: boolean;
  deleteFromOutlook: boolean;
  moveToMailboxFolderEmailAddress: string|null;
  moveToMailboxFolderId: string|null;
  moveToMailboxFolderName: string|null;
}
export interface Group extends UnsavedGroup {
  groupId: number;
}

export enum AuthenticationType {
  Azure = 0,
  Keycloak = 1,
}